import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'do_pay_slips_contain_accurate_information_on_worker'

export const dataPointDefinition = {
  retracedId: 'do_pay_slips_contain_accurate_information_on_worker',
  name: 'Do pay slips contain accurate information on worker wages in a detailed and comprehensive manner for workers?',
  description:
    'The intent of this question is to understand specifically whether workers can read their pay slip and understand its contents. For example, do workers know where to find their base rate of pay? Or what certain legal withholdings mean?',
  meta: {
    slcpMeta: {
      key: 'wb-16--3',
      number: 'WB-WAGE-110',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-16--3', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35070,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
